import { Box, Button, Grid, Dialog, DialogContent, DialogTitle, IconButton, Paper, Table, TableBody, TableContainer, TableHead, Typography, Tooltip, TablePagination } from "@mui/material";
import React, { useEffect, useState, forwardRef, useRef } from "react";
import styles from '../../../styles.module.css';
import { useDispatch, useSelector } from "react-redux";
import { AddButton, Breadcrumb, CustomePopover, dateConversion, DateConversionOnEntryPage, DeleteDialog, ExcelDownload, HandleSort, SearchInput, StyledTableCell, StyledTableRow } from "../../reusableComponent/Reusables";
import { NavLink } from "react-router-dom";
import ProductionEntryPrint from "./ProductionEntryPrint";
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import ReactToPrint from "react-to-print";
import productionentryService from "../../../services/productionentry.Service";
import HeaderSection from "../../reusableComponent/HeaderSection";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";

import CloseIcon from '@mui/icons-material/Close';
import CustomPagination from "../../reusableComponent/CustomPagination";

const ComponentToPrintWrapper = ({ quotationPrint }) => {
  const ref = useRef();
  return (
    <div style={{ display: "flex" }}>
      <ReactToPrint
        trigger={() => <span style={{ display: 'flex', justifyContent: 'center' }}> <PrintOutlinedIcon /> <span style={{ marginLeft: '22px' }}>  Print Record </span> </span>}
        content={() => ref.current}
      />
      <div style={{ display: 'none' }}>
        <ProductionEntryPrint ref={ref} salesOrderPrint={quotationPrint} />
      </div>
    </div>
  );
};

const ProductionEntryList = () => {
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.userInfo;
 const user_role = userD?.result?.userInfo?.user_role
  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState();
  const [sortBy, setSortBy] = useState(null);
  const totalCount = useSelector(state => state.production_entry.total_count || 0);
  const defaultRowsPerPage = useSelector(state => state.production_entry.rows_per_page || 15);
  const [rows, setRows] = useState([]);
  const [searchKey, setSearchKey] = useState('');
  const [customermap, setCustomer] = useState([]);
  const [selectedCylinderDetails, setSelectedCylinderDetails] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [total_count,setTotalCount]=useState(null)
    const [openCylinderDialog, setOpenCylinderDialog] = useState(false);
      const [dialogTitle, setDialogTitle] = useState("Cylinder Details");
 useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);


  const fields = [
    'entry_no',
    'entry_date',
    'batch_no',
    'batch_date',
    'shift',
    'prod_code',
    'cylinder_count',
    'plant_name',
  ];

  const labels = [
    'Entry No',
    'Entry Date',
    'Batch No',
    'Batch Date',
    'Shift',
    'Product code',
    'No Of cylinder',
    'From_Plant'
  ];

  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage
  });

  useEffect(() => {
    setController(prev => ({
      ...prev,
      rowsPerPage: defaultRowsPerPage,
      page: 0,
    }));
  }, [defaultRowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setController({
      ...controller,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  const fetchData = async (params = null) => {
    try {
      const fetchParams = params || {
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey: searchKey,
      };
      const response = await productionentryService.getProductionEntryList(fetchParams);
      setRows(response);
    } catch (error) {
      setSuccessMessage("Error fetching data");
    }
  };

  const handleSearch = async (e) => {
    const searchValue = e.target.value;
    setSearchKey(searchValue);

    const params = {
      page: controller.page,
      size: searchValue === '' ? controller.rowsPerPage : (rows[0]?.total_count || 0),
      searchKey: searchValue,
    };

    try {
      await fetchData(params);
    } catch (error) {
      console.error("Error in handleSearch:", error);
      setSuccessMessage("Error searching data");
    }
  };

  useEffect(() => {
    fetchData();
  }, [controller]);

  const deleteRecord = async (id) => {
    try {
      await productionentryService.editDeleteProductionEntry({
        entry_id: id,
        changedUpdatedValue: "delete"
      });
      setIsDelete(false);
      fetchData();
      setSuccessMessage("Record deleted successfully");
    } catch (error) {
      setSuccessMessage("Error deleting record");
    }
  };

  const handleDelete = (functions) => {
    setIsDelete(true);
    setDeleteInfo(functions);
  };

  const handleClose = (event, reason) => {
    setIsDelete(false);
    setDeleteInfo(null);
  };

  const [successMessage, setSuccessMessage] = useState(""); // Initialize as empty string

  // Sort rows by entry_date descending
  const sortedRows = [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));
  // Calculate pagination info

  const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;


  
  console.log('Pagination Info:', { startRecord, endRecord, totalCount, effectiveTotalCount, paginationInfo });
  const handleOpenDialog = (row) => {
    setSelectedRow(row);
    setSelectedCylinderDetails(safeParse(row.child_details));
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null);
    setSelectedCylinderDetails([]);
  };

  const safeParse = (jsonString) => {
    if (jsonString && typeof jsonString === "string") {
      try {
        return JSON.parse(jsonString);
      } catch (e) {
        console.error("Error parsing JSON", e);
        return [];
      }
    }
    return [];
  };
    const handleCloseCylinderDialog = () => {
    setOpenCylinderDialog(false);
    setSelectedCylinderDetails([]);
    setDialogTitle("Cylinder Details");
  }
  
const getOwnerDisplay = (cylinder) => {
  if (!cylinder) return 'N/A';
  const { owner, customer_id } = cylinder;
  if (owner === 'TGPL') return 'TGPL';
  if (owner === 'customer' && customer_id && customermap[customer_id]) {
    return customermap[customer_id];
  }
  return owner || 'N/A'; 
};
 const handleCylinderCountClick = (row) => {
  try {
    const details = JSON.parse(row.child_details || '[]'); // Parse child_details
    setSelectedCylinderDetails(details);
    setDialogTitle(`Cylinder Details for ${row.entry_no}`);
    setOpenCylinderDialog(true);
  } catch (error) {
    console.error("Error parsing child_details:", error);
    setSuccessMessage("Error loading cylinder details");
    setSelectedCylinderDetails([]);
  }
};

const getCylinderCount = (row) => {
  
  if (row.cylinder_count) {
    return row.cylinder_count;
  }

  try {
    const details = JSON.parse(row.child_details || '[]');
    return details.length || 0;
  } catch (error) {
    console.error("Error parsing child_details:", error);
    return 0;
  }
};
  
  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb
          routeSegments={[
            { name: 'Production Entry List' },
          ]}
        />

        <HeaderSection
          title="PRODUCTION ENTRY LIST"
          addNewPath="/productionEntries/add-pe"
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={sortedRows}
          fields={fields}
          labels={labels}
          filename="Production Entry List"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
          disableAddNew={user_role === "admin" || user_role === "management"}
        />

        <Paper sx={{ width: '100%', }}>
          <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
            <Table size="small" stickyHeader>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell sx={{ width: '15%' }} align="Left" className={`${styles.table_head}`} onClick={() => HandleSort('entry_date', sortBy, setSortBy, rows)}>
                    Entry NO <span className={`${styles.sort_icon}`}> {sortBy === 'entry_no' ? '▲' : '▼'} </span>
                  </StyledTableCell>
                  <StyledTableCell sx={{ width: '15%' }} align="Left" className={`${styles.table_head}`} onClick={() => HandleSort('entry_date', sortBy, setSortBy, rows)}>
                    Date <span className={`${styles.sort_icon}`}> {sortBy === 'entry_date' ? '▲' : '▼'} </span>
                  </StyledTableCell>
                  <StyledTableCell align="Left" className={`${styles.table_head}`} onClick={() => HandleSort('batch_no', sortBy, setSortBy, rows)}>
                    Batch No <span className={`${styles.sort_icon}`}> {sortBy === 'batch_no' ? '▲' : '▼'} </span>
                  </StyledTableCell>
                  <StyledTableCell align="Left" className={`${styles.table_head}`} onClick={() => HandleSort('batch_date', sortBy, setSortBy, rows)}>
                    Batch Date <span className={`${styles.sort_icon}`}> {sortBy === 'batch_date' ? '▲' : '▼'} </span>
                  </StyledTableCell>
                  <StyledTableCell align="Left" sx={{ width: '10%' }} className={`${styles.table_head}`} onClick={() => HandleSort('shift', sortBy, setSortBy, rows)}>
                    Shift <span className={`${styles.sort_icon}`}> {sortBy === 'shift' ? '▲' : '▼'} </span>
                  </StyledTableCell>
                  {/* <StyledTableCell align="Left" sx={{ width: '10%' }} className={`${styles.table_head}`} onClick={() => HandleSort('prod_code', sortBy, setSortBy, rows)}>
                    Product Code <span className={`${styles.sort_icon}`}> {sortBy === 'prod_code' ? '▲' : '▼'} </span>
                  </StyledTableCell> */}
                  <StyledTableCell align="center" sx={{ width: '15%' }} className={`${styles.table_head}`} onClick={() => HandleSort('cyl_no', sortBy, setSortBy, rows)}>
                    No Of Cylinders <span className={`${styles.sort_icon}`}> {sortBy === 'cyl_no' ? '▲' : '▼'} </span>
                  </StyledTableCell>
                  <StyledTableCell align="Left" className={`${styles.table_head}`} onClick={() => HandleSort('oprater_type', sortBy, setSortBy, rows)}>
                    Operator <span className={`${styles.sort_icon}`}> {sortBy === 'oprater_type' ? '▲' : '▼'} </span>
                  </StyledTableCell>
                  {/* <StyledTableCell align="Left" className={`${styles.table_head}`} onClick={() => HandleSort('oprater_type', sortBy, setSortBy, rows)}>
                     From plant<span className={`${styles.sort_icon}`}> {sortBy === 'oprater_type' ? '▲' : '▼'} </span>
                  </StyledTableCell> */}
                  {/* <StyledTableCell align="center" sx={{ width: '10%' }} className={`${styles.table_head}`}>
                    Action
                  </StyledTableCell> */}
                </StyledTableRow>
              </TableHead>
              <TableBody sx={{ backgroundColor: '#fff' }}>
                {Array.isArray(rows) && rows.map((row, index) => (
                  <StyledTableRow
                    key={row.so_no}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                    <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                      <Typography
                        sx={{ fontSize: "12px", cursor: "pointer", color: "#1976d2", }}
                        onClick={() => handleOpenDialog(row)}
                      >
                        {row.entry_no}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell align="left" className={`${styles.list_table_body}`}>
  {row.entry_date ? new Intl.DateTimeFormat('en-GB').format(new Date(row.entry_date)) : "N/A"}
</StyledTableCell>

                    <StyledTableCell align="Left" className={`${styles.list_table_body}`}>
                      {row.batch_no}
                    </StyledTableCell>
                    <StyledTableCell align="left" className={`${styles.list_table_body}`}>
  {row.entry_date ? new Intl.DateTimeFormat('en-GB').format(new Date(row.batch_date)) : "N/A"}
</StyledTableCell>

                    <StyledTableCell align="Left" className={`${styles.list_table_body}`}>
                      {row.shift}
                    </StyledTableCell>
                    {/* <StyledTableCell align="Left" className={`${styles.list_table_body}`}>
                      {row.prod_code}
                    </StyledTableCell> */}
                  <StyledTableCell align="center" className={`${styles.list_table_body}`}>
  <Tooltip title="Click here to view cylinder details" arrow>
    <span
      onClick={() => handleCylinderCountClick(row)}
      style={{ cursor: 'pointer' }}
    >
      {getCylinderCount(row)} 
    </span>
  </Tooltip>
</StyledTableCell>
                    <StyledTableCell align="Left" className={`${styles.list_table_body}`}>
                      {row.oprater_type}
                    </StyledTableCell>

                    {/* <StyledTableCell align="Left" className={`${styles.list_table_body}`}>
                      {row.plant_name}
                    </StyledTableCell> */}
                    {/* <StyledTableCell align="center">
                      <CustomePopover row={row}    handleCancel={false} handleDelete={false} linkTo="/productionEntries/add-pe" handlePrint={false} showEdit={false} />
                    </StyledTableCell> */}
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
                                     <CustomPagination
  page={controller.page}
  rowsPerPage={controller.rowsPerPage}
  totalCount={total_count || 0}
  onPageChange={(newPage) => handleChangePage(null, newPage)}
/>
        </Paper>


        {/* ── PRODUCTION DETAILS (Redesigned like Sales Order) (NO RADIUS) ── */}
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          maxWidth={false}
          sx={{
            "& .MuiDialog-paper": {
              margin: "auto",
              width: "92vw",
              maxHeight: "85vh",
              boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
              overflow: "hidden",
              fontFamily: "'Inter', Arial, sans-serif",
              borderRadius: "0px", // NO RADIUS
            },
          }}
        >
          {/* ── Dialog Header (Navy) ── */}
          <Box sx={{ background: "#1C3A5E", padding: "14px 22px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#fff", letterSpacing: "0.5px", fontFamily: "'Inter', Arial, sans-serif" }}>
              PRODUCTION DETAILS
            </Typography>
            <IconButton onClick={handleCloseDialog} sx={{ color: "#fff", p: 0.5 }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <DialogContent sx={{ padding: "20px 24px", background: "#F4F7FB", overflowY: "auto" }}>

            {/* ── Production Information Card ── */}
            <Box sx={{ background: "#fff", border: "1px solid #E2E8F0", borderRadius: "0px", overflow: "hidden", mb: 2.5 }}>
              <Box sx={{ background: "#2A4F7A", padding: "9px 18px" }}>
                <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#fff", fontFamily: "'Inter', Arial, sans-serif", letterSpacing: "0.4px" }}>
                  📋  Production Information
                </Typography>
              </Box>

              <Box>
                <Grid container>
                  {/* Row 1 */}
                  <Grid item xs={12} sm={6} md={12/7} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Entry No</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#1C3A5E", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.entry_no || "N/A"}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={12/7} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Entry Date</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{dateConversion(selectedRow?.entry_date)}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={12/7} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Product Code</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.prod_code || "N/A"}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={12/7} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Product Desc</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{selectedRow?.prod_description || "N/A"}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={12/7} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Batch Pressure</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.batch_pressure || "N/A"}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={12/7} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Calcium Carbide (KG)</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.carbide || "N/A"}</Typography>
                  </Grid>
                  {/* <Grid item xs={12} sm={6} md={12/7} sx={{ borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Acetone Used (KG)</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.acetone || "N/A"}</Typography>
                  </Grid> */}

                  {/* Row 2 */}
                  <Grid item xs={12} sm={6} md={12/7} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Batch No</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.batch_no || "N/A"}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={12/7} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Batch Date</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{dateConversion(selectedRow?.batch_date)}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={12/7} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Batch Start Time</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.batch_start_time || "N/A"}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={12/7} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Batch End Time</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.batch_end_time || "N/A"}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={12/7} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Filling Duration</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.filling_duration || "N/A"}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={12/7} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Shift</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.shift || "N/A"}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={12/7} sx={{ borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Operator Name</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.oprater_type || "N/A"}</Typography>
                  </Grid>

                </Grid>
              </Box>
            </Box>

            {/* ── Cylinder Details Table ── */}
            <Box sx={{ background: "#fff", border: "1px solid #E2E8F0", borderRadius: "0px", overflow: "hidden" }}>
              

              <TableContainer sx={{ maxHeight: "320px" }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <StyledTableRow>
                      {["Sr No", "Cylinder No", "Tag No", "UOM", "Initial Wt", "Final Wt", "Qty Filled", "Remarks"].map((header) => (
                        <StyledTableCell
                          key={header}
                          align="center"
                          sx={{
                            backgroundColor: "#1C3A5E !important",
                            color: "#fff !important",
                            fontFamily: "'Inter', Arial, sans-serif",
                            fontWeight: 700,
                            fontSize: "12px",
                            padding: "10px 12px",
                            whiteSpace: "nowrap",
                            borderRight: "1px solid rgba(255,255,255,0.1)",
                          }}
                        >
                          {header}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {selectedCylinderDetails.length > 0 ? (
                      selectedCylinderDetails.map((row, index) => (
                        <StyledTableRow
                          key={index}
                          sx={{
                            backgroundColor: index % 2 === 0 ? "#fff" : "#F8FAFC",
                            "&:hover": { backgroundColor: "#EBF4FF" },
                          }}
                        >
                          {[
                            index + 1,
                            row.cyl_no || "N/A",
                            row.tag_no || "N/A",
                            row.uom || "N/A",
                            row.initial_wt || "N/A",
                            row.final_wt || "N/A",
                            row.qty_filled || "N/A",
                            row.remarks || "N/A"
                          ].map((val, ci) => (
                            <StyledTableCell
                              key={ci}
                              align="center"
                              sx={{
                                fontSize: "12px",
                                fontFamily: "'Inter', Arial, sans-serif",
                                color: "#2D3748",
                                padding: "8px 12px",
                                borderBottom: "1px solid #EDF2F7",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {val}
                            </StyledTableCell>
                          ))}
                        </StyledTableRow>
                      ))
                    ) : (
                      <StyledTableRow>
                        <StyledTableCell
                          colSpan={8}
                          align="center"
                          sx={{ py: 5, fontSize: "13px", color: "#A0AEC0", fontFamily: "'Inter', Arial, sans-serif" }}
                        >
                          No cylinder details available
                        </StyledTableCell>
                      </StyledTableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

          </DialogContent>

          {/* ── Dialog Footer ── */}
          <Box sx={{ padding: "12px 24px", background: "#F8FAFC", borderTop: "1px solid #E2E8F0", display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={handleCloseDialog}
              sx={{
                background: "#E53E3E",
                color: "#fff",
                fontSize: "13px",
                fontWeight: 600,
                textTransform: "none",
                padding: "7px 20px",
                borderRadius: "0px", // NO RADIUS
                fontFamily: "'Inter', Arial, sans-serif",
                "&:hover": { background: "#971f16" },
              }}
            >
              Close
            </Button>
          </Box>
        </Dialog>

        <Dialog
  open={openCylinderDialog}
  onClose={handleCloseCylinderDialog}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    {dialogTitle}
    <IconButton aria-label="close" onClick={handleCloseCylinderDialog}>
      <CloseIcon />
    </IconButton>
  </DialogTitle>
  <DialogContent>
    <Table size="small">
      <TableHead>
        <StyledTableRow>
          <StyledTableCell>Cylinder No</StyledTableCell>
          <StyledTableCell>Tag No</StyledTableCell>
          <StyledTableCell>Owner</StyledTableCell>
        </StyledTableRow>
      </TableHead>
      <TableBody>
        {selectedCylinderDetails.length > 0 ? (
          selectedCylinderDetails.map((cylinder, index) => (
            <StyledTableRow key={index}>
              <StyledTableCell>{cylinder.cyl_no || 'N/A'}</StyledTableCell>
              <StyledTableCell>{cylinder.tag_no || 'N/A'}</StyledTableCell>
              <StyledTableCell>{getOwnerDisplay(cylinder)}</StyledTableCell>
            </StyledTableRow>
          ))
        ) : (
          <StyledTableRow>
            <StyledTableCell colSpan={3} align="center">
              No cylinder details available
            </StyledTableCell>
          </StyledTableRow>
        )}
      </TableBody>
    </Table>
  </DialogContent>
</Dialog>
        <DeleteDialog
          open={isDelete}
          handleClose={handleClose}
          deleteInfo={deleteInfo}
          deleteRecord={deleteRecord}
          deleteID={deleteInfo?.entry_id || null}
          displayName={deleteInfo?.entry_id || ''}
        />
        <ReusableSnackbar
          open={successMessage !== ""}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={30000}
          vertical="top"
          horizontal="right"
        />



      </Box>
    </Box>
  );  
};

export default ProductionEntryList;